export default __webpack_public_path__ + "static/media/ic-star-outLine.ba85bd0d.svg";